import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ROUTE_REGISTRY } from "./routeRegistry";
import { BootstrapGate } from "@/features/bootstrap/BootstrapGate";
import { useAuth } from "../auth";
import { useAppAccess } from "@/features/access-control/hooks/useAppAccess";

const PROP_ALIASES = {};

function pickProps(keys, context) {
  return keys.reduce((acc, key) => {
    const alias = PROP_ALIASES[key] ?? key;
    acc[alias] = context[key];
    return acc;
  }, {});
}

export default function AppRouter({ isDemo, routeContext }) {
  const { user } = useAuth();
  const location = useLocation();
  const { isPaused } = useAppAccess();

  const visibleRoutes = ROUTE_REGISTRY.filter(
    (route) => route.roles.includes(user.role) && !(isDemo && route.demoHidden),
  );

  return (
    <Routes
      key={`routes-${user.role}-${location.pathname}`}
      location={location}
    >
      <Route path="demo" element={<Navigate to="/" replace />} />
      <Route path="/demosignup" element={<Navigate to="/" replace />} />

      {visibleRoutes.map(
        ({
          path,
          component: Screen,
          props: propKeys,
          requiresBootstrap,
          accessRequired,
        }) => {
          const element =
            isPaused && accessRequired ? (
              <Navigate to="/" replace />
            ) : requiresBootstrap ? (
              <BootstrapGate>
                <Screen {...pickProps(propKeys, routeContext)} />
              </BootstrapGate>
            ) : (
              <Screen {...pickProps(propKeys, routeContext)} />
            );

          return <Route key={path} path={path} element={element} />;
        },
      )}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
